/* ─────────────────────────────────────────
   TIRAS NASALES ELEVEIT — Shopify Theme JS
   All functions namespaced under window.TN
───────────────────────────────────────── */

window.TN = window.TN || {};

/* ── Image switcher ── */
TN.initCarousel = function(carouselImages) {
  var currentImgIdx = 0;
  var stickyImg = document.getElementById('sticky-bar-img');
  if (stickyImg && carouselImages.length > 0) {
    stickyImg.src = carouselImages[0];
  }

  window.switchImg = function(thumb, src) {
    document.querySelectorAll('.thumb').forEach(function(t) { t.classList.remove('active'); });
    thumb.classList.add('active');
    currentImgIdx = carouselImages.indexOf(src);
    var main = document.getElementById('main-product-img');
    if (main) main.src = src;
  };

  window.goToImg = function(idx) {
    if (carouselImages.length === 0) return;
    if (idx < 0) idx = carouselImages.length - 1;
    if (idx >= carouselImages.length) idx = 0;
    currentImgIdx = idx;
    var main = document.getElementById('main-product-img');
    if (main) main.src = carouselImages[idx];
    var thumbs = document.querySelectorAll('.thumb');
    thumbs.forEach(function(t) { t.classList.remove('active'); });
    if (thumbs[idx]) {
      thumbs[idx].classList.add('active');
      if (thumbs[idx].scrollIntoView) {
        thumbs[idx].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
      }
    }
  };

  window.tnGetCurrentImg = function() { return currentImgIdx; };

  window.tnScrollThumbs = function(dir) {
    var strip = document.getElementById('tn-thumbs');
    if (!strip) return;
    var first = strip.querySelector('.thumb');
    var step  = first ? (first.offsetWidth + 8) * 2 : 140;
    strip.scrollBy({ left: dir * step, behavior: 'smooth' });
  };

  /* Swipe / drag on main image */
  (function() {
    var startX = 0, isDragging = false;
    var wrap = document.getElementById('main-img-wrap');
    if (!wrap) return;

    wrap.addEventListener('mousedown',  function(e) { startX = e.clientX; isDragging = true; });
    wrap.addEventListener('mousemove',  function(e) { if (isDragging) e.preventDefault(); });
    wrap.addEventListener('mouseup',    function(e) {
      if (!isDragging) return;
      isDragging = false;
      var diff = e.clientX - startX;
      if (Math.abs(diff) > 40) goToImg(currentImgIdx + (diff < 0 ? 1 : -1));
    });
    wrap.addEventListener('mouseleave', function() { isDragging = false; });
    wrap.addEventListener('touchstart', function(e) { startX = e.touches[0].clientX; }, { passive: true });
    wrap.addEventListener('touchend',   function(e) {
      var diff = e.changedTouches[0].clientX - startX;
      if (Math.abs(diff) > 40) goToImg(currentImgIdx + (diff < 0 ? 1 : -1));
    });
  })();

  return { getCurrent: function() { return currentImgIdx; } };
};

/* ── Urgency counter ── */
TN.initUrgency = function(maxStock, minStock) {
  maxStock = maxStock || 12;
  minStock = minStock || 3;
  var stock   = Math.floor(Math.random() * (maxStock - minStock + 1)) + minStock;
  var viewers = Math.floor(Math.random() * 8) + 11;

  function updateUrgency() {
    var countEl = document.getElementById('stock-count');
    var viewEl  = document.getElementById('viewers-count');
    if (countEl) countEl.textContent = stock;
    if (viewEl)  viewEl.textContent = viewers;
  }

  updateUrgency();

  function scheduleStockDrop() {
    var delay = (Math.random() * 45 + 10) * 1000;
    setTimeout(function() {
      if (stock > minStock) { stock--; updateUrgency(); }
      scheduleStockDrop();
    }, delay);
  }
  scheduleStockDrop();

  setInterval(function() {
    viewers = Math.max(8, viewers + (Math.random() > .5 ? 1 : -1));
    var viewEl = document.getElementById('viewers-count');
    if (viewEl) viewEl.textContent = viewers;
  }, (Math.random() * 30 + 30) * 1000);
};

/* ── Color selector ── */
window.selectColor = function(el, name) {
  document.querySelectorAll('.color-swatch').forEach(function(s) {
    s.classList.remove('active');
    s.style.borderColor = 'transparent';
  });
  el.classList.add('active');
  el.style.borderColor = '';
  var label = document.getElementById('selected-color');
  if (label) label.textContent = name;
  TN.updateVariant();
};

/* ── Color variant resolver (Negro / Blanco) ── */
TN.initColorVariants = function(variantsJson, colorOptionName) {
  var variants    = variantsJson;
  var colorOption = colorOptionName || 'Color';

  TN.updateVariant = function() {
    var selectedColor = (document.getElementById('selected-color') || {}).textContent || '';
    var match = variants.find(function(v) {
      return v.options.indexOf(selectedColor) > -1 || selectedColor === '';
    });
    if (match) {
      var idInput = document.getElementById('tn-variant-id');
      if (idInput) idInput.value = match.id;
      /* Update unit price reference so bundle prices stay correct */
      window.tnUnitPrice = match.price;
    }
  };

  TN.updateVariant();
};

/* ── Money formatter (matches Shopify MX pesos) ── */
TN.formatMoney = function(cents) {
  var amount = (cents / 100).toFixed(2);
  return '$' + amount.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

/* ── Sticky bar visibility ── */
TN.initStickyBar = function() {
  var stickyBar = document.querySelector('.sticky-bar');
  var mainCta   = document.getElementById('main-cta');
  if (!mainCta || !stickyBar) return;
  var observer = new IntersectionObserver(
    function(entries) {
      var entry = entries[0];
      var scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      stickyBar.classList.toggle('visible', scrolledPast);
      document.body.classList.toggle('sticky-active', scrolledPast);
    },
    { threshold: 0 }
  );
  observer.observe(mainCta);
};

/* ── Accordion toggle (product page) ── */
window.toggleAcc = function(btn) {
  var item = btn.closest('.acc-item');
  var body = item.querySelector('.acc-body');
  var open = item.classList.contains('open');
  document.querySelectorAll('.acc-item.open').forEach(function(el) {
    el.classList.remove('open');
    el.querySelector('.acc-body').style.maxHeight = '0';
  });
  if (!open) {
    item.classList.add('open');
    body.style.maxHeight = body.scrollHeight + 'px';
  }
};

/* ── FAQ accordion toggle ── */
window.toggleFaq = function(btn) {
  var item = btn.closest('.faq-item');
  var body = item.querySelector('.faq-body');
  var open = item.classList.contains('open');
  document.querySelectorAll('.faq-item.open').forEach(function(el) {
    el.classList.remove('open');
    el.querySelector('.faq-body').style.maxHeight = '0';
  });
  if (!open) {
    item.classList.add('open');
    body.style.maxHeight = body.scrollHeight + 'px';
  }
};

/* ── Override "Seguir comprando" en cart drawer vacío ── */
TN.patchEmptyCartButton = function() {
  var observer = new MutationObserver(function() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    var links = drawer.querySelectorAll('a');
    links.forEach(function(link) {
      if (link.textContent.trim().toLowerCase().indexOf('seguir comprando') > -1 && !link._tnPatched) {
        link._tnPatched = true;
        link.addEventListener('click', function(e) {
          e.preventDefault();
          /* Cerrar el drawer */
          var closeBtn = drawer.querySelector('[aria-label="Cerrar"], .drawer__close, button[aria-label="Close"]');
          if (closeBtn) closeBtn.click();
          else drawer.removeAttribute('open');
        });
      }
    });
  });
  observer.observe(document.body, { childList: true, subtree: true });
};
TN.patchEmptyCartButton();

/* ── Open cart drawer (Shrine Pro) ── */
TN.openCartDrawer = function() {
  /* 1) Click en el icono del header (mismo camino que abre el drawer manualmente) */
  var cartSelectors = [
    'a[href="/cart"]',
    '[data-cart-toggle]',
    '.cart-toggle',
    '.header__icon--cart',
    'button[aria-controls*="cart"]',
    '#cart-icon-bubble'
  ];
  for (var i = 0; i < cartSelectors.length; i++) {
    var el = document.querySelector(cartSelectors[i]);
    if (el && !el.classList.contains('tn-nav-cart')) {
      console.log('[TN] Abriendo drawer via click en:', cartSelectors[i]);
      el.click();
      return;
    }
  }
  /* 2) Fallback: método nativo del custom element <cart-drawer> */
  var drawer = document.querySelector('cart-drawer');
  if (drawer) {
    if (typeof drawer.open === 'function') {
      console.log('[TN] Abriendo drawer via drawer.open()');
      try { drawer.open(); return; } catch (e) { console.warn('[TN] drawer.open() falló:', e); }
    }
    /* 3) Fallback manual: aplicar clases que Shrine usa para abrir */
    console.log('[TN] Abriendo drawer via classList manual');
    drawer.classList.add('animate', 'active');
    drawer.setAttribute('open', '');
    var innerDrawer = drawer.querySelector('#CartDrawer');
    if (innerDrawer) innerDrawer.classList.add('animate', 'active');
    document.body.classList.add('overflow-hidden');
    return;
  }
  console.warn('[TN] No se encontró cart-drawer ni icono del carrito');
};

/* ── AJAX Add to Cart (abre cart drawer del tema) ── */
TN.initAjaxCart = function() {
  var form = document.getElementById('tn-product-form');
  if (!form) return;

  form.addEventListener('submit', function(e) {
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    var btnText = btn.textContent;
    btn.textContent = 'Agregando...';
    btn.disabled = true;

    var variantId = form.querySelector('[name="id"]').value;
    var qty = form.querySelector('[name="quantity"]').value;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId), quantity: parseInt(qty) })
    })
    .then(function(r) {
      if (!r.ok) throw new Error('Error al agregar');
      return r.json();
    })
    .then(function(item) {
      console.log('[TN] Producto agregado:', item);
      btn.textContent = '✓ Agregado';
      setTimeout(function() {
        btn.textContent = btnText;
        btn.disabled = false;
      }, 1500);

      /* Refrescar las secciones EN EL CONTEXTO DE LA PÁGINA ACTUAL
         (window.location.pathname) para que los upsells con recomendaciones
         dinámicas o condicionados por product.handle se rendericen bien.
         Antes usábamos '/' (homepage), por eso no aparecían upsells. */
      var sectionsUrl = window.location.pathname + '?sections=cart-drawer,cart-icon-bubble';
      fetch(sectionsUrl)
        .then(function(r) { return r.json(); })
        .then(function(sections) {
          /* Actualizar el contenido del drawer con el HTML fresco */
          if (sections['cart-drawer']) {
            var cartDrawer = document.querySelector('cart-drawer');
            if (cartDrawer) {
              var parsedDrawer = new DOMParser()
                .parseFromString(sections['cart-drawer'], 'text/html')
                .querySelector('cart-drawer');
              if (parsedDrawer) {
                cartDrawer.innerHTML = parsedDrawer.innerHTML;
                cartDrawer.classList.remove('is-empty');
              } else {
                console.warn('[TN] No se encontró <cart-drawer> en la respuesta');
              }
            }
          }
          /* Actualizar el icono/burbuja del carrito */
          if (sections['cart-icon-bubble']) {
            var bubble = document.getElementById('cart-icon-bubble');
            if (bubble) {
              var parsedBubble = new DOMParser()
                .parseFromString(sections['cart-icon-bubble'], 'text/html')
                .getElementById('cart-icon-bubble');
              if (parsedBubble) {
                bubble.innerHTML = parsedBubble.innerHTML;
              }
            }
          }
          /* Notificar a Shrine que el carrito cambió */
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          if (window.PUB_SUB_EVENTS && typeof publish === 'function') {
            try { publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'tn-ajax-add' }); } catch (_) {}
          }
        })
        .catch(function(e) { console.error('[TN] Error refrescando secciones:', e); })
        .finally(function() {
          /* Abrir el drawer (siempre, haya o no fallado el refresh) */
          TN.openCartDrawer();
        });
    })
    .catch(function(err) {
      console.error('[TN] Error:', err);
      btn.textContent = btnText;
      btn.disabled = false;
    });
  });
};

/* ── Scroll reveal ── */
TN.initScrollReveal = function() {
  var targets = document.querySelectorAll('.use-card, .feat-card, .bun-card, .rev-photo, .b-card, .cross-card');
  var io = new IntersectionObserver(function(entries) {
    entries.forEach(function(e) {
      if (e.isIntersecting) {
        e.target.style.opacity = '1';
        e.target.style.transform = 'translateY(0)';
        io.unobserve(e.target);
      }
    });
  }, { threshold: 0.1 });

  targets.forEach(function(el) {
    el.style.opacity = '0';
    el.style.transform = 'translateY(16px)';
    el.style.transition = 'opacity .45s ease, transform .45s ease';
    io.observe(el);
  });
};

/* ── Reviews (tipo Loox, sin app) ── */
TN.initReviews = function(sectionId) {
  var root = document.getElementById('tn-reviews-' + sectionId);
  if (!root) return;

  var section = root.querySelector('[data-tn-reviews]');
  var grid = root.querySelector('[data-tn-rv-grid]');
  if (!grid) return;

  var cards = Array.prototype.slice.call(grid.querySelectorAll('[data-tn-rv-card]'));
  var initialVisible = parseInt(section && section.getAttribute('data-initial-visible'), 10) || 5;
  var shown = initialVisible;

  var loadMoreBtn = root.querySelector('[data-tn-rv-loadmore]');

  // Apply: limit to N shown cards
  function applyVisibility() {
    cards.forEach(function(card, idx) {
      if (idx < shown) {
        card.classList.remove('is-hidden');
      } else {
        card.classList.add('is-hidden');
      }
    });

    if (loadMoreBtn) {
      if (shown >= cards.length) {
        loadMoreBtn.setAttribute('hidden', '');
      } else {
        loadMoreBtn.removeAttribute('hidden');
      }
    }
  }

  // Load more (+N cards per click)
  if (loadMoreBtn) {
    loadMoreBtn.addEventListener('click', function() {
      shown += initialVisible;
      applyVisibility();
    });
  }

  // Lightbox
  var lightbox = root.querySelector('[data-tn-rv-lightbox]');
  var lightboxImg = root.querySelector('[data-tn-rv-lightbox-img]');
  var lightboxClose = root.querySelector('[data-tn-rv-lightbox-close]');

  function openLightbox(src) {
    if (!lightbox || !lightboxImg) return;
    lightboxImg.src = src;
    lightbox.removeAttribute('hidden');
    document.body.style.overflow = 'hidden';
  }
  function closeLightbox() {
    if (!lightbox) return;
    lightbox.setAttribute('hidden', '');
    if (lightboxImg) lightboxImg.src = '';
    document.body.style.overflow = '';
  }

  root.querySelectorAll('[data-tn-rv-photo]').forEach(function(photoWrap) {
    photoWrap.addEventListener('click', function() {
      var full = photoWrap.getAttribute('data-full');
      if (full) openLightbox(full);
    });
  });

  if (lightboxClose) lightboxClose.addEventListener('click', closeLightbox);
  if (lightbox) {
    lightbox.addEventListener('click', function(e) {
      if (e.target === lightbox) closeLightbox();
    });
  }
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && lightbox && !lightbox.hasAttribute('hidden')) closeLightbox();
  });

  // Initial render
  applyVisibility();
};
